export default __webpack_public_path__ + "static/media/logo.e28e6ed6.png";